export const BASE_URL = 'https://dev.assistgo.de';

export const AUTH_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2MTg5MzhiNjQzN2M5ODFlZjA3OTY1ZDMiLCJpYXQiOjE3NDQ4OTk4NDd9._9yWxutwKsiuf0anRndcP60VWC_MsG74BlJ9wnJxNeg';

// SSO Configuration - Fetched dynamically from backend
export const SSO_CONFIG = {
  redirectUri: window.location.origin,
  scopes: ['User.Read', 'profile', 'email']
};

// Debug function to check current redirect URI
export function getRedirectUri() {
  const hostname = window.location.hostname;
  const origin = window.location.origin;
  
  // Development environment
  const isDev = hostname === 'localhost' || hostname === '127.0.0.1';
  
  // Office/Outlook domains
  const isOffice = hostname.includes('outlook.') || 
                   hostname.includes('office.') || 
                   hostname.includes('substrate.office.com');
  
  let uri;
  
  if (isDev) {
    // Development - use localhost
    uri = 'https://localhost:3000';
  } else if (isOffice) {
    // Office/Outlook environment - use the current origin
    uri = origin;
  } else {
    // Other environments (like Netlify)
    uri = origin;
  }
  

  
  return uri;
}

// Cache for Azure credentials
let azureCredentialsCache = null;

// Function to fetch Azure credentials from backend
export async function getAzureCredentials(instance) {
  // Return cached credentials if available
  if (azureCredentialsCache) {
    return azureCredentialsCache;
  }

  try {
    const url = `https://${instance}.assistgo.de/api/user/azure`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch Azure credentials: ${response.status}`);
    }

    const data = await response.json();
    
    if (!data.azure_client_id || !data.azure_tenant_id) {
      throw new Error('Invalid Azure credentials received from backend');
    }

    // Cache the credentials
    azureCredentialsCache = {
      clientId: data.azure_client_id,
      tenantId: data.azure_tenant_id
    };

    return azureCredentialsCache;

  } catch (error) {
    throw new Error('Unable to fetch Azure configuration. SSO may not be available.');
  }
}

// Function to check if Azure credentials are available
export function isAzureConfigured() {
  return azureCredentialsCache !== null;
}

// Function to clear cached credentials (useful for logout or instance change)
export function clearAzureCredentials() {
  azureCredentialsCache = null;
} 